import { type Breadcrumb } from "~/components/molecules/Breadcrumbs";
import Footer from "~/components/organisms/Footer";
import Header from "~/components/organisms/Header";
import { cn } from "~/lib/utils";
import AuthStickyNav from "~/components/organisms/AuthStickyNav";

export default function PageContainer({
    className,
    children,
    breadcrumbs,
}: {
    children: React.ReactNode;
    className?: string;
    breadcrumbs?: Breadcrumb[];
}) {
    return (
        <div
            className={cn("relative flex min-h-screen w-full grow flex-col bg-blue-10", className)}
        >
            <Header breadcrumbs={breadcrumbs} />
            <main className="relative flex h-full grow flex-col">{children}</main>
            <Footer />
            <AuthStickyNav />
        </div>
    );
}
